/**
 * @typedef {Object} SocialLink
 * @property {string} id
 * @property {string} label
 * @property {string} href
 * @property {boolean} [placeholder]
 */

/** @type {SocialLink[]} */
export const socialLinks = [
  {
    id: 'linkedin',
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/antoine-levyy/',
  },
  {
    id: 'x',
    label: 'X',
    href: 'https://x.com/AntoineLevy27',
  },
  {
    id: 'github',
    label: 'GitHub',
    href: 'https://github.com/AntoineLevyy',
  },
  {
    id: 'delphi',
    label: 'Delphi',
    href: 'https://www.delphi.ai/antoine-levy',
  },
];

export const contactEmail = 'antoine.levy27@gmail.com';
